<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

html, body {
  background: $slate800;
  box-shadow: 0 500px 0 $slate800;
}

* {
  font-family: $fontstack;
  box-sizing: border-box;
}

button {
  font-size: 16px;
  font-weight: bold;
  padding: 10px 14px;
  border: none;
  cursor: pointer;
  outline: none;
  border-radius: 8px;
  transition: $transition;

  &:hover {
    &.primary {background: $emerald600;}
    &.secondary {background: $slate800;}
    &.tertiary {background: $slate500; color: $white;}
    &.alt {background: $blue600;}
  }

  &.primary {
    background: $emerald500;
    color: $white;
  }

  &.secondary {
    background: $slate700;
    color: $white;
  }

  &.tertiary {
    border: 2px solid $slate500;
    background: transparent;
    color: $slate500;
  }

  &.alt {
    background: $blue500;
    color: $white;
  }

  &:disabled {
    cursor: default;
    background: $slate300;
    color: $slate500;
  }
}

.bold {font-weight: 700;}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
